import React, { useState } from 'react'
import { Paper, FormControl, TextField, Grid, Button } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
    paper: {
        padding: theme.spacing(3),
    },
    selectList: {
        height: 40,
    },
    loadingSection: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '300px',
        width: '100%',
    },
}))

const SSO = () => {
    const classes = useStyles()
    const [serviceDetails, setServiceDetails] = useState({})
    // const [isLoadingData, setIsLoadingData] = useState(true)

    // useEffect(() => {
    //     const managedService = userService.getManagedService()

    //     ;(async function getServiceAsync() {
    //         try {
    //             await serviceService
    //                 .getService(managedService.id)
    //                 .then(result => {
    //                     setServiceDetails(result)
    //                     setIsLoadingData(false)
    //                 })
    //         } catch (exception) {
    //             console.log(exception)
    //         }
    //     })()
    // }, [])

    return (
        <>
            <Paper className={classes.paper}>
                <Grid
                    container
                    direction='row'
                    justify='flex-start'
                    alignItems='flex-start'
                    spacing={3}>
                    <Grid item xs={4}>
                        <FormControl>
                            <TextField
                                label={'Partner Identity Provider Name'}
                                value={
                                    serviceDetails.partnerIdentityProviderName
                                }
                                onChange={e => {
                                    const val = e.target.value
                                    setServiceDetails({
                                        ...serviceDetails,
                                        serviceName: val,
                                    })
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                        <FormControl>
                            <TextField
                                label={'User Reference Type'}
                                value={serviceDetails.userReferenceType}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                        <FormControl>
                            <TextField
                                label={'Service Id'}
                                value={serviceDetails.serviceId}
                                disabled
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <Grid
                    container
                    direction='row'
                    justify='flex-start'
                    alignItems='flex-start'
                    spacing={3}>
                    <Grid item xs={4}>
                        <FormControl>
                            <TextField
                                label={'Username Prefix'}
                                value={serviceDetails.usernamePrefix}
                                onChange={e => {
                                    const val = e.target.value
                                    setServiceDetails({
                                        ...serviceDetails,
                                        usernamePrefix: val,
                                    })
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={4}>
                        <FormControl>
                            <TextField
                                label={'Client Id'}
                                value={serviceDetails.clientId}
                                onChange={e => {
                                    const val = e.target.value
                                    setServiceDetails({
                                        ...serviceDetails,
                                        clientId: val,
                                    })
                                }}
                            />
                        </FormControl>
                    </Grid>

                    <Grid item xs={4}>
                        <FormControl>
                            <TextField
                                label={'Destination Application Url'}
                                value={serviceDetails.destinationApplicationUrl}
                            />
                        </FormControl>
                    </Grid>
                </Grid>

                <Grid
                    container
                    direction='row'
                    justify='flex-start'
                    alignItems='flex-start'
                    spacing={3}>
                    <Grid item xs={4}>
                        <FormControl>
                            <TextField
                                label={'User Access Url'}
                                value={serviceDetails.destinationApplicationUrl}
                            />
                        </FormControl>
                    </Grid>

                    <Grid
                        container
                        item
                        xs={12}
                        direction='row'
                        justify='flex-start'>
                        <Button variant='contained' color='secondary'>
                            Update
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
        </>
    )
}

export default SSO
